import { render, staticRenderFns } from "./DetailsTicketBox.vue?vue&type=template&id=b7cc0818"
import script from "./DetailsTicketBox.vue?vue&type=script&lang=ts"
export * from "./DetailsTicketBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports